import React from 'react';
import cx from 'classnames';
import { FormattedMessage } from 'react-intl';
import type * as Types from '@xingternal/pages-graphql-types';

import styles from './styles.css';
import { PINNED } from '../constants';

const STATE_DRAFT = 'DRAFT';
const STATE_PUBLISHED = 'PUBLISHED';
const STATE_SCHEDULED = 'SCHEDULED';
const STATE_HIDDEN = 'HIDDEN';

type NewsStatusFlagProps = {
  state: Types.PostingPublicationState | 'PINNED',
  className?: string,
}
const NewsStatusFlag = ({ state, className }: NewsStatusFlagProps) => {
  let text;
  switch (state) {
    case STATE_PUBLISHED:
      text = 'NEWS_MODULE_PUBLISHED_STORY_LABEL';
      break;
    case STATE_DRAFT:
      text = 'NEWS_MODULE_DRAFT_LABEL';
      break;
    case STATE_SCHEDULED:
      text = 'NEWS_MODULE_SCHEDULE_LABEL';
      break;
    case STATE_HIDDEN:
      text = 'NEWS_MODULE_HIDDEN_LABEL';
      break;
    case PINNED:
      text = 'NEWS_MODULE_TOP_LABEL';
      break;
  }
  return (
    <span className={cx(styles.statusFlag, className)}>
      <FormattedMessage id={text} />
    </span>
  );
};

export { NewsStatusFlag };
